// SwitchBar.jsx
import React, { useEffect } from "react";

const SwitchBar = ({
  activeTab,
  setActiveTab,
  tabs = [],
  setSearch,
  setPage,
  setRows,
  setCount,
  module,
  setPageSize,
  mode = "toggle", // "toggle" | "default"
  allowToggleOff = false,
}) => {

  useEffect(() => {
    if (mode === "default" && tabs.length > 0 && !activeTab) {
      setActiveTab(tabs[0].value);
    }
  }, [mode, tabs, activeTab, setActiveTab]);

  const handleTabClick = (tabId) => {
    if (activeTab === tabId && !allowToggleOff) return;

    if (mode === "toggle") {
      if (allowToggleOff && activeTab === tabId) {
        setActiveTab(null);
      } else {
        setActiveTab(tabId);
      }
    }

    if (module === "country-tab") {
      setPage(1);
      setCount(0);
      setPageSize(10);
    }

    if (setSearch) setSearch("");
  };

  return (
    <ul className="nav voucher_nav">
      {tabs?.map((item, index) => {
        const isActive = activeTab === item.value;
        const isDisabled =
          mode === "default" && (tabs.length === 1 || isActive);

        return (
          <li key={index}>
            <button
              className={`nav_btn ${isActive ? "active" : ""}`}
              id={item.value}
              onClick={() => !isDisabled && handleTabClick(item.value)}
              type="button"
              role="tab"
              aria-controls="page_setup"
              aria-selected={isActive}
              disabled={isDisabled}
              style={{
                cursor: isDisabled ? "not-allowed" : "pointer",
                opacity: isDisabled ? 0.7 : 1,
              }}
            >
              {item.title}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default SwitchBar;


// import React, { useEffect } from "react";

// const SwitchBar = ({
//   activeTab,
//   setActiveTab,
//   tabs = [],
//   setSearch,
//   setPage,
//   setRows,
//   setCount,
//   module,
//   setPageSize,
//   mode = "toggle", // "toggle" | "default"
// }) => {
//   useEffect(() => {
//     if (mode === "default" && tabs.length > 0 && !activeTab) {
//       setActiveTab(tabs[0].value);
//     }
//   }, [mode, tabs, activeTab, setActiveTab]);

//   const handleTabClick = (tabId) => {
//     if (mode === "toggle") {
//       setActiveTab(tabId);
//     }

//     if (module === "country-tab") {
//       setPage(1);
//       setCount(0);
//       setPageSize(10);
//     }

//     if (setSearch) setSearch("");
//   };

//   return (
//     <ul className="nav voucher_nav">
//       {tabs?.map((item, index) => {
//         const isActive = activeTab === item.value;
//         const isDisabled =
//           mode === "default" && (tabs.length === 1 || isActive);

//         return (
//           <li key={index}>
//             <button
//               className={`nav_btn ${isActive ? "active" : ""}`}
//               id={item.value}
//               onClick={() => !isDisabled && handleTabClick(item.value)}
//               type="button"
//               role="tab"
//               aria-controls="page_setup"
//               aria-selected={isActive}
//               disabled={isDisabled}
//               style={{
//                 cursor: isDisabled ? "not-allowed" : "pointer",
//                 opacity: isDisabled ? 0.7 : 1,
//               }}
//             >
//               {item.title}
//             </button>
//           </li>
//         );
//       })}
//     </ul>
//   );
// };

// export default SwitchBar;
